
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "SideBar",
  setup() {
    let bc = new BroadcastChannel("hql23");
    return {
      //必须返回
      bc,
    };
  },
  mounted() {
    console.log(this.bc);
  },
  methods: {
    onConfirm() {},
    gotoPlace(num: number) {
      this.bc.postMessage({ type: "workshopChanged", data: num });
    },
  },
});
